import { render } from "./SubBanner.vue?vue&type=template&id=a5102ea6"
import script from "./SubBanner.vue?vue&type=script&lang=js"
export * from "./SubBanner.vue?vue&type=script&lang=js"

import "./SubBanner.vue?vue&type=style&index=0&id=a5102ea6&lang=scss"

import exportComponent from "/Users/Sacha/Projects/muziekdichtbij/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__